import { render, staticRenderFns } from "./MSignature.vue?vue&type=template&id=255295b4&scoped=true"
import script from "./MSignature.vue?vue&type=script&lang=js"
export * from "./MSignature.vue?vue&type=script&lang=js"
import style0 from "./MSignature.vue?vue&type=style&index=0&id=255295b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255295b4",
  null
  
)

export default component.exports